export default __webpack_public_path__ + "img/31c23e5bbf42d3c9dabdafec81145f84.svg";